import React, { useState, useEffect } from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { Steps, StepsProvider, useSteps } from "react-step-builder";
import momentTime from 'moment-timezone';
//Material
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { DropzoneDialog } from "material-ui-dropzone";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import { MaterialUIDatePickers } from "./../../stories/hook-controls/datepicker/datepicker";
//Component
import { Modal } from "../../stories/modalSchedule";
import FormInput from "../../stories/hook-controls/input";
import { ReactTable } from "../../stories/react-table";
import moment from "moment";
//Function
import { setDataToFormHookV2, isEmptyStr } from "../../utils/common-function";
import { formatDateTime } from "../../utils/common-function"
import { TextField, Divider } from "@material-ui/core";
import * as api from "./api";
import * as common from "./../../utils/common-function";
import * as alertDialog from "./../../utils/alert";
import { checkDateRange } from "../../utils/date";


const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(1),
        // marginBottom: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginLeft: 5,
        minWidth: 100,
    },
    formControlDate: {
        marginLeft: theme.spacing(1),
        minWidth: 90,
        align: "right",
    },
    textLabelRight: {
        margin: theme.spacing(1),
        minWidth: 180,
        textAlign: "left",
        align: "right",
    },
    textRight: {
        margin: theme.spacing(1),
        minWidth: 120,
        align: "right",
    },

    selectDate: {
        //marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        minWidth: 120,
        align: "right",
    },
    checkWeekly: {
        margin: theme.spacing(1),
        minWidth: 80,
    },
    labelInput: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(2),
        minWidth: 170,
    },
    labelInputRadio: {
        marginTop: theme.spacing(-1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        minWidth: 175,
    },
    labelInputCheckBox: {
        // marginTop: theme.spacing(-1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        minWidth: 175,
    },
    labelInputCheckBoxEmail: {
        // marginTop: theme.spacing(-1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        minWidth: 175,
    },
    textInput: {
        margin: theme.spacing(1),
        minWidth: 200,
    },
    selectEmpty: {
        marginTop: theme.spacing(1),
    },
    labelDate: {
        marginTop: theme.spacing(-1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        minWidth: 120,
    },
    textJob: {
        marginLeft: theme.spacing(0),
        minWidth: 120,
        textAlign: "left",
        align: "left",
    },
    textSql: {
        marginLeft: theme.spacing(0),
        minWidth: 120,
        textAlign: "left",
        align: "left",
    },
    textLabel: {
        color: '#000'
    },
    textLabelHelper: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    textXS12: {
        marginLeft: theme.spacing(1),
    },
    textExtendLabelHelper: {
        marginLeft: '5px',
        marginTop: "20px",
        fontSize: "12px"
    },
    textXS12Label: {
        marginLeft: '5px',
        marginTop: "-10px",
        minWidth: 100,
        display: 'inherit'
    },
    textExtendLabel: {
        margin: 'auto',
    }
}));

function EditJobSchedule(props) {
    const classes = useStyles();
    const { open } = props;
    const { JobGUID, ...otherprops } = props;
    const [step, setStep] = useState(0);
    const [hideButton, setHideButton] = useState(0);
    const step_form = step + 1;
    const method = useForm();
    const { register, getValues } = method;
    const { setValue, setError, clearErrors, errors, control } = method;
    const [lstInitScreen, setlstInitScreen] = useState([]);
    const [typeRunJob, settypeRunJob] = useState(1);
    const [hiddenFreeText, setHiddenFreeText] = useState(false);
    const [hiddenInputMail, setHiddenInputMail] = useState(true);
    const [hiddenWeekly, sethiddenWeekly] = useState(true);
    const [hiddenMonthly, sethiddenMonthly] = useState(true);
    const [state, setState] = React.useState({
        checkedNotiEmail: false,
        MONTHLY_DATE_END: false
    });
    const [typeOutput, settypeOutput] = React.useState('');
    const [sqlText, setSqlText] = useState('');
    const [jobName, setJobName] = useState('');
    const [hourTime, setHourTime] = useState('');
    const [minuteTime, setMinuteTime] = useState('');
    const [emailList, setEmailList] = useState('');
    const [listWeekly, setlistWeekly] = useState([]);
    const [listMonthly, setlistMonthly] = useState([]);
    const [dayMonth,setDayMonth] = useState('');
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [initDate, setInitDate] = useState(1);
    const [maxendDate, setMaxEndDate] = useState(null);
    const [minendDate, setMinEndDate] = useState(null);
    const [dateDiffExtend, setDateDiffExtend] = useState(0);
    const [endMonth, setEndMonth] = useState(true);
    const [listDisableTime, setListDisableTime] = useState([]);
    const [extendDate, setExtendDate] = useState(new Date());
    const txtEndOfmonth = "End of Month";


    const handleFileUpload = (files) => {
        if (!files) return null;
    }
    const resetDisable = () => {
        setHourTime('');
        setMinuteTime('');
        setListDisableTime([]);
    }
    const handleChangeEndOFMonthly = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    }
    const handleChange = (event) => {
        settypeRunJob(event.target.value);

        if (event.target.value === 3) {
            sethiddenWeekly(true);
            sethiddenMonthly(false);
        } else if (event.target.value === 2) {
            sethiddenWeekly(false);
            sethiddenMonthly(true);
        } else {
            sethiddenWeekly(true);
            sethiddenMonthly(true);
        }
        resetDisable();
        CheckSlotAvailable(getSchedule(), hourTime, minuteTime, event.target.value);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(getSchedule(), hourTime, event.target.value);
    };
    const handleChangeHour = (event) => {
        //console.log(typeRunJob);
        setHourTime(event.target.value);
        setMinuteTime('');
        CheckSlotAvailable(getSchedule(), event.target.value, '', typeRunJob);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(getSchedule(), event.target.value, typeRunJob);
    };
    const handleChangeMinute = (event) => {
        setMinuteTime(event.target.value);
        CheckSlotAvailable(getSchedule(), hourTime, event.target.value, typeRunJob);//        dateSelect, hour, minute, typesched
    };

    const handleChangeWeekly = (event) => {
        resetDisable();
        setlistWeekly(getValues().WEEKLY_DATE);
        CheckSlotAvailable(getValues().WEEKLY_DATE.join(','), hourTime, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(getValues().WEEKLY_DATE.join(','), hourTime, typeRunJob);
    };
    // const handleChangeMonthly = (event) => {
    //     resetDisable();
    //     setlistMonthly(getValues().MONTHLY_DATE);
    //     CheckSlotAvailable(getValues().MONTHLY_DATE.join(','), hourTime, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
    //     fetchNotAvalible(getValues().MONTHLY_DATE.join(','), hourTime, typeRunJob);
    //     //setStatScreen();
    //     ////console.log(event.target.value);
    //     //setState({ ...state, [event.target.name]: event.target.value });
    // };
    const handleChangeMonthly = (day) => {
        resetDisable();
        let daySelect = day.target.value;
        //console.log(daySelect);
        setDayMonth(daySelect);
        CheckSlotAvailable(daySelect, hourTime, minuteTime, typeRunJob);//        dateSelect, hour, minute, typesched
        fetchNotAvalible(daySelect, hourTime, typeRunJob);
    };
    const CheckSlotAvailable = async (dateSelect, hour, minute, typesched) => {
        if (hour === '' || minute === '') {
            return;
        }
        console.log(dateSelect);
        if (typesched !== 1 && (dateSelect === '' || dateSelect === null)) {
            return;
        }

        let param = {
            Schedule_Type: typesched,
            Hour: hour,
            Minute: minute,
            ScheduleDate: dateSelect,
            JOB_GUID : JobGUID,
        };

        let res = await api.CheckSlotJobAvailable(param);
        if (res.ResultCode === 20) { //
            alertDialog.ErrorDialog(res?.Message);
            return;
        }
    };

    const handleChangeEndDate = (date) => {
        // if (initDate === 1) {
        //     setMaxEndDate(addDays(endDate, lstInitScreen?.Effective_End ?? 0));
        // }
        setInitDate(0);
        setEndDate(date);
    }


    const handleChangeNotiMail = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
        if (event.target.checked) {
            setHiddenInputMail(false);
        } else {
            setHiddenInputMail(true);
        }

    }

    const fetchNotAvalible = async (dateSelect, hour, typesched) => {
        if (hour === '') {
            return;
        }
        //console.log(dateSelect);
        if (typesched !== 1 && (dateSelect === '' || dateSelect === null)) {
            return;
        }
        let param = {
            Schedule_Type: typesched,
            Hour: hour,
            ScheduleDate: dateSelect
        };
        let res = await api.GetNotAvalableTime(param);
        setListDisableTime(res);

    };

    useEffect(() => {
        if (!open) return;
        if (typeof JobGUID === "undefined") return;

        fetch();

    }, [JobGUID, setValue, open]);

    const fetch = async () => {
        let res = await api.getInitScreen();
        setlstInitScreen(res);
        if (JobGUID !== 0) {
            setInitEdit(JobGUID, res);
        }
    };
    const setInitEdit = async (JobGUID, lstInit) => {
        let param = { "JOB_GUID": JobGUID };
        let res = await api.GetJobInfo(param);
        if (res?.SCHEDULE_TYPE === 2) {
            setlistWeekly(res?.SCHEDULE_DATE);
            setlistMonthly([]);
        } else if (res?.SCHEDULE_TYPE === 3) {
            setlistWeekly([]);
            setlistMonthly(res?.SCHEDULE_DATE)
            setDayMonth(res?.SCHEDULE_DATE[0] ?? "");
        } else {
            setlistWeekly([]);
            setlistMonthly([])
        }

        setSqlText(res?.SQL_QUERY);
        setJobName(res?.JOB_NAME);
        setEmailList(res?.EMAIL_NOTIFICATION);
        settypeRunJob(res?.SCHEDULE_TYPE);
        setHourTime(res?.SCHEDULE_TIME_HOUR);
        setMinuteTime(res?.SCHEDULE_TIME_TIME);
        setStartDate(new Date(res?.START_DATE));
        setEndDate(new Date(res?.END_DATE));
        setExtendDate(new Date(res?.END_DATE));
        setState({
            checkedNotiEmail: res?.ISNOTIFICATION === "0" ? false : true,
            MONTHLY_DATE_END: res?.IS_END_MONTH === 1 ? true : false
        })
        setHiddenInputMail(res?.ISNOTIFICATION === "0" ? true : false);
        settypeOutput(res?.OUTPUT_TYPE);
        const currentDate = GetLocalDateFormat(new Date());
        // console.log(currentDate);
        let pStartDate = common.formatDate(new Date(res?.START_DATE));
        let pEndDate = common.formatDate(new Date(res?.END_DATE));
        let pCurrent = common.formatDate(new Date());
        const diffMin = (Math.abs(new Date(pCurrent) - new Date(pStartDate))) / (1000 * 60 * 60 * 24);
        const diffMax = (Math.abs(new Date(pEndDate) - new Date(pCurrent))) / (1000 * 60 * 60 * 24);

        setDateDiffExtend(diffMax);
        setEndMonth(res?.IS_END_MONTH === 1 ? true : false);

        fetchNotAvalible(getScheduleDate(res?.SCHEDULE_TYPE, res?.SCHEDULE_DATE), res?.SCHEDULE_TIME_HOUR, res?.SCHEDULE_TYPE);
        //setMinEndDate(addDays(new Date(res?.START_DATE), 1));

        //console.log(new Date(pStartDate));
        //console.log(new Date(pCurrent));
        //console.log(new Date(res?.START_DATE));
        //console.log(new Date());
        if (new Date(pStartDate) <= new Date(pCurrent)) {
            setMinEndDate(addDays(new Date(), 1));
        }
        else {
            setMinEndDate(addDays(new Date(res?.START_DATE), 1));
        }

        if (diffMax <= lstInit?.DateExtend) {
            setMaxEndDate(addDays(new Date(res?.END_DATE), lstInit?.Effective_End ?? 0))
        }
        else {
            setMaxEndDate(new Date(res?.END_DATE));
        }
        //setDisableExtend();
    };

    const addDays = (date, number) => {
        const newDate = new Date(date);
        return new Date(newDate.setDate(newDate.getDate() + number));
    }

    const ClearError = async (e) => {
        clearErrors(e.target.name);
    };
    const GetLocalDateFormat = (pDate) => {
        return momentTime.tz(pDate, "Asia/Bangkok").format();
    }

    const getScheduleDate = (scheduleType, scheduleDate) => {
        if (scheduleType === 2) {
            return scheduleDate.join(',');
        } else if (scheduleType === 3) {
            return scheduleDate.join(',');
        }
        else {
            return "";
        }
    }

    const getSchedule = () => {
        if (typeRunJob === 2) {
            return listWeekly.join(',');
        } else if (typeRunJob === 3) {
            return dayMonth;
        }
        else {
            return null;
        }
    }
    const onExtendDate = () => {
        setEndDate(addDays(extendDate, lstInitScreen?.Effective_End ?? 0));
    }
    const SaveEditJob = async () => {
        if (hourTime === '') { //check choose hour
            alertDialog.ErrorDialog("Please Choose Hour.");
            return;
        }
        if (minuteTime === '') { //check choose minute
            alertDialog.ErrorDialog("Please Choose Minute.");
            return;
        }
        if (typeRunJob === 2 && listWeekly.length <= 0) { //check choose weekly
            alertDialog.ErrorDialog("Please Choose Day.");
            return;
        }
        // if (typeRunJob === 3 && listMonthly.length <= 0 && !state.MONTHLY_DATE_END) { //check choose monthly
        //     alertDialog.ErrorDialog("Please Choose Day.");
        //     return;
        // }
        if (typeRunJob === 3 && dayMonth === '') { //check choose monthly
            alertDialog.ErrorDialog("Please Choose Day.");
            return;
        }
        if (state.checkedNotiEmail && getValues().EMAIL_TEXT === '') {
            alertDialog.ErrorDialog("Please input Email.");
            return;
        }
        let param = {
            jobName: jobName,
            JOB_GUID: JobGUID,
            endDate: endDate,
            endOfMonth: state.MONTHLY_DATE_END,
            scheduleType: typeRunJob,
            scheduleDate: getSchedule(),
            scheduleHour: hourTime,
            scheduleTime: minuteTime,
            notiEmail: state.checkedNotiEmail,
            listEmail: getValues().EMAIL_TEXT,
        };
        let res = await api.SaveEditJobSchedule(param);

        if (res.ResultCode === 10) { //Success
            alertDialog.SuccessShowButtonCloseModal("You Job Schedule setting update completed.", props);

        }
        if (res.ResultCode === 20) {
            alertDialog.ErrorDialog(res?.Message);
            return;
        }

    }
    const onCloseModal = async () => {
        let resConfirm = await alertDialog.ConfirmCommon("Do you want to close ?", "Yes", "No");
        if (!resConfirm) return;
        props.onClose();

    }

    const Form = () => {
        return (<AddEdit />);
    }

    const AddEdit = () => {

        return (
            <>
                <FormProvider {...method}>
                    <Grid container spacing={3}>
                        <Grid item xs={4}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.textLabelRight}>
                                        <InputLabel className={classes.textLabel}>Select Schedule Type : </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2} className={classes.textRight}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        {/* <InputLabel id="simple-select-outlined-label">Age</InputLabel> */}
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="TYPE_SCHEDULE"
                                            defaultValue={lstInitScreen?.ListScheduleType ? typeRunJob : ""}
                                            onChange={handleChange}
                                        //disabled={typeof JobGUID === "undefined" ? false : true}
                                        >
                                            {lstInitScreen?.ListScheduleType?.map((item) => (
                                                <MenuItem key={item?.schedule_type_id} value={item.schedule_type_id}>{item?.schedule_type}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} hidden={typeRunJob === 3 ? false : true}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.textLabelRight}>
                                        <InputLabel className={classes.textLabel}>Select Day : </InputLabel>
                                    </FormControl>
                                </Grid>
                                 <Grid item xs={4} className={classes.textRight}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="simple-select-outlined-label">Day</InputLabel>
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="MONTHLY_DATE"
                                            label="Day"
                                            defaultValue={dayMonth ? dayMonth : ""}
                                            onChange={handleChangeMonthly}

                                        >
                                            {lstInitScreen?.ListMonthly?.map((item) => (
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            ))}
                                                <MenuItem key={txtEndOfmonth} value={txtEndOfmonth} >{txtEndOfmonth}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.textLabelRight}>
                                        <InputLabel className={classes.textLabel}>Select Time: </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={3} className={classes.formControlDate}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="simple-select-outlined-label">Hour</InputLabel>
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="HOUR_TIME"
                                            defaultValue={lstInitScreen?.ListHourlyTime ? hourTime : ""}
                                            label="Hour"
                                            onChange={handleChangeHour}
                                        // disabled={typeof JobGUID === "undefined" ? false : true}
                                        >
                                            {lstInitScreen?.ListHourlyTime?.map((item) => (
                                                <MenuItem key={item} value={item}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={2}>
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="simple-select-outlined-label">Minute</InputLabel>
                                        <Select
                                            labelId="simple-select-outlined-label"
                                            id="simple-select-outlined"
                                            name="MINUTE_TIME"
                                            defaultValue={lstInitScreen?.ListMinuteTime ? minuteTime : ""}
                                            label="Minute"
                                            onChange={handleChangeMinute}
                                        //disabled={typeof JobGUID === "undefined" ? false : true}
                                        >
                                            {lstInitScreen?.ListMinuteTime?.map((item) => (
                                                <MenuItem key={item} value={item} disabled={listDisableTime?.includes(item)}>{item}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.labelDate}>
                                        <InputLabel className={classes.textLabel}>Start Date: </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={5} className={classes.selectDate}>
                                    <MaterialUIDatePickers name="DATE_FROM" label="From" className={classes.formControl}
                                        format="dd-MMM-yyyy"
                                        variant="dialog"
                                        value={startDate}
                                        minDate={startDate}
                                        disabled={typeof JobGUID === "undefined" ? false : true}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <FormControl variant="outlined" className={classes.labelDate}>
                                        <InputLabel className={classes.textLabel}>End Date: </InputLabel>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={5} className={classes.selectDate}>
                                    <MaterialUIDatePickers name="DATE_To" label="To" className={classes.formControl}
                                        format="dd-MMM-yyyy"
                                        variant="dialog"
                                        value={endDate}
                                        onChange={handleChangeEndDate}
                                        minDate={minendDate}
                                        maxDate={maxendDate}
                                        //minDate={dateDiffExtend <= lstInitScreen?.DateExtend ? minendDate : addDays(minendDate, 1)}
                                        //maxDate={dateDiffExtend <= lstInitScreen?.DateExtend ? addDays(maxendDate, lstInitScreen?.Effective_End ?? 0) : maxendDate}
                                        minDateMessage="Date Expired"
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={8}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    {lstInitScreen?.ListWeekly?.map((item, index) => (
                                        <FormControl key={index} variant="outlined" className={classes.checkWeekly} hidden={typeRunJob === 2 ? false : true}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        onChange={handleChangeWeekly}
                                                        name="WEEKLY_DATE"
                                                        color="primary"
                                                        value={item}
                                                        inputRef={register}
                                                        defaultChecked={listWeekly.includes(item)}
                                                    // disabled={typeof JobGUID === "undefined" ? false : true}
                                                    />
                                                }
                                                label={item}
                                            />
                                        </FormControl>
                                    ))}
                                    {/* {lstInitScreen?.ListMonthly?.map((item, index) =>

                                        <FormControl key={index} variant="outlined" className={classes.checkWeekly} hidden={typeRunJob === 3 ? false : true}>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        onChange={handleChangeMonthly}
                                                        name="MONTHLY_DATE"
                                                        color="primary"
                                                        value={item}
                                                        inputRef={register}
                                                        defaultChecked={listMonthly.includes(item)}
                                                    // disabled={typeof JobGUID === "undefined" ? false : true}
                                                    />
                                                }
                                                label={item}
                                            />
                                        </FormControl>
                                    )}
                                    <FormControl key="MONTH_END" variant="outlined" className={classes.checkWeekly} hidden={typeRunJob === 3 ? false : true}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={state.MONTHLY_DATE_END}
                                                    name="MONTHLY_DATE_END"
                                                    onChange={handleChangeEndOFMonthly}
                                                    color="primary"
                                                //disabled={typeof JobGUID === "undefined" ? false : true}
                                                //defaultChecked={endMonth}
                                                />
                                            }
                                            label="End of Month"
                                        />
                                    </FormControl> */}
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}> </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={10} container spacing={1} className={classes.textExtendLabel}>
                                <Grid item xs={5} className={classes.textXS12Label}>
                                    <Button variant="contained" color="primary" className={classes.formControl} onClick={onExtendDate}
                                        disabled={dateDiffExtend > lstInitScreen?.DateExtend ? true : false}
                                    >
                                        Extend
                                    </Button>
                                    <InputLabel className={classes.textExtendLabelHelper}>Extend 90 Days</InputLabel>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}>Job Name: </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} className={classes.textXS12}>
                                <TextField
                                    id="outlined-full-width"
                                    label=""
                                    name="JOB_NAME"
                                    inputRef={register}
                                    style={{ margin: 8 }}
                                    //placeholder="Placeholder"
                                    helperText="Fill out with English letters  only. The following special characters are not allowed ~ ! @ # $ % ^ * - _ = + [ { ] } / ; : , . ? Only _ (underscore ) is allowed"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant={typeof JobGUID === "undefined" ? "outlined" : "filled"}
                                    defaultValue={jobName}
                                    disabled={typeof JobGUID === "undefined" ? false : true}
                                />
                            </Grid>
                        </Grid>

                        <Grid container spacing={1}>
                            <Grid item ls={4}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}>Script : </InputLabel>
                                </FormControl>
                            </Grid>

                            <Grid item xs={8} className={classes.textXS12}>

                                <FormControl variant="outlined" className={classes.textSql} hidden={hiddenFreeText} fullWidth={true}>
                                    <TextField
                                        id="outlined-full-width"
                                        label=""
                                        style={{ margin: 8 }}
                                        multiline
                                        rows={10}
                                        fullWidth
                                        name="SCRIPT_TEXT"
                                        margin="normal"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        inputRef={register}
                                        defaultValue={sqlText}
                                        variant={typeof JobGUID === "undefined" ? "outlined" : "filled"}
                                        disabled={typeof JobGUID === "undefined" ? false : true}
                                    />
                                </FormControl>

                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={4}>
                                <FormControl variant="outlined" className={classes.labelInputRadio}>
                                    <InputLabel className={classes.textLabel}>Output Type : </InputLabel>
                                </FormControl>
                                <InputLabel className={classes.textLabelHelper}>(If Need)</InputLabel>

                            </Grid>
                            <Grid item xs={8} className={classes.textXS12}>
                                <RadioGroup row aria-label="typeOutput" name="TYPE_OUTPUT" value={typeOutput}
                                >
                                    {/* <FormControlLabel value="" control={<Radio />} label="None" disabled={typeof JobGUID === "undefined" ? false : true} /> */}
                                    <FormControlLabel value="CSV" control={<Radio />} label="CSV" disabled={typeof JobGUID === "undefined" ? false : true} />
                                    <FormControlLabel value="Text" control={<Radio />} label="Text" disabled={typeof JobGUID === "undefined" ? false : true} />
                                </RadioGroup>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item ls={4}>
                                <FormControl variant="outlined" className={classes.labelInputCheckBoxEmail}>
                                    <InputLabel className={classes.textLabel}>Notification by Email : </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8} className={classes.textXS12}>
                                <FormControl variant="outlined" className={classes.textInput}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                //checked={emailList !== null ? true : false}
                                                checked={state.checkedNotiEmail}
                                                onChange={handleChangeNotiMail}
                                                name="checkedNotiEmail"
                                                color="primary"
                                            //disabled={typeof JobGUID === "undefined" ? false : true}
                                            />
                                        }
                                        label="Yes"
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item ls={2}>
                                <FormControl variant="outlined" className={classes.labelInput}>
                                    <InputLabel className={classes.textLabel}> </InputLabel>
                                </FormControl>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    id="outlined-full-width"
                                    label=""
                                    style={{ margin: 8 }}
                                    multiline
                                    rows={10}
                                    fullWidth
                                    inputRef={register}
                                    name="EMAIL_TEXT"
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    variant="outlined"
                                    defaultValue={emailList}
                                    //hidden={emailList !== null ? false : true}
                                    hidden={hiddenInputMail}
                                //disabled={typeof JobGUID === "undefined" ? false : true}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </>
        );
    }
    return (
        <Modal
            {...otherprops}
            disableBackdropClick={true}
            //hiddenNext={dateDiffExtend > lstInitScreen?.DateExtend ? true : false}
            onNext={SaveEditJob} NextText="Submit"
            onClose={onCloseModal}
            CloseText="Cancel"
            hiddenPrev={step === 0 ? true : false}
            title="Edit Job Schedule"
            maxWidth='lg'
        >
            <Form />
        </Modal>
    );

}


export default EditJobSchedule;
